// extracted by mini-css-extract-plugin
export default {"page":"Connectors_page__tstUo","tabBar":"Connectors_tabBar__e3II3","tab":"Connectors_tab__1AplW","active":"Connectors_active__i1JFi","tabContent":"Connectors_tabContent__VrPlJ"};